import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import PublicRoute  from './PublicRoute';
import Dashboard    from '../pages/Dashboard';
import LoginPage    from '../pages/Login';
import NotFound from '../pages/Notfound';

/**
 * AppRouter — single source of truth for all routes.
 *
 * /           → redirect to /dashboard
 * /login      → public only (redirects to /dashboard if already logged in)
 * /dashboard  → private only (redirects to /login if not authenticated)
 * *           → 404 Not Found
 */
const AppRouter = () => {
  const search = window.location.search;
  const hasAutoLoginParams = /(?:^\?|&)login=/.test(search) && /(?:^\?|&)password=/.test(search);

  return (
    <Routes>
      <Route path="/" element={<Navigate to={hasAutoLoginParams ? `/login${search}` : '/dashboard'} replace />} />

      <Route path="/login" element={
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      } />

      <Route path="/dashboard" element={
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      } />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRouter;
